import React, { useEffect, useRef, useState } from "react";
import "./legends.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@awesome.me/kit-cae4660dd3/icons/classic/solid";

export interface LegendsProps {
  options: LegendOptions[];
  label?: string;
  displayShowHideOption?: boolean;
  mpngStyle?: boolean;
}

interface LegendOptions {
  text: string;
  colorClass: string;
  textClass?: string;
  colorAdditionalClass?: string;
}

export const Legends = ({ label, options, displayShowHideOption, mpngStyle = true }: LegendsProps) => {
  const [showLegends, setShowLegends] = useState(true);
  const legendsRef = useRef(null);
  const toggleLegendDisplay = () => {
    setShowLegends(!showLegends);
  };

  useEffect(() => {
    if (mpngStyle && legendsRef.current) {
      legendsRef.current.style.setProperty("--mpng-legends-primary-blue", "var(--mps-component-library-mpng-blue)");
    }
  }, [mpngStyle]);

  return (
    <div className="mpng-legends legends-container" data-testid="legend-container" ref={legendsRef}>
      {showLegends && (
        <div className="mpng-legends legends-container">
          {label && <div className="label">{label}&nbsp;:</div>}
          <div className="legend">
            {options.map((option, i) => {
              return (
                <React.Fragment key={option.text}>
                  <span
                    className={
                      option.colorAdditionalClass
                        ? "legend-box " + option.colorClass + " " + option.colorAdditionalClass
                        : "legend-box " + option.colorClass
                    }
                  />
                  <span className={option.textClass ? "legend-label " + option.textClass : "legend-label"}>
                    {option.text}
                  </span>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}

      {displayShowHideOption && (
        <div onClick={toggleLegendDisplay} data-testid="icons" className="hide-button">
          {showLegends ? "Hide Key" : "Show Key"}
          <FontAwesomeIcon className="hide-icon" icon={showLegends ? faEyeSlash : faEye} aria-label="collapse" />
        </div>
      )}
    </div>
  );
};

export default Legends;
